import React, { useEffect } from "react";
import { StyledDinerSelection } from "./DinerSelection";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDinerProfile, setSelectedGuest } from "../store/checkoutSlice";
import LocationItem from "./LocationItem";
import GuestItem from "./GuestItem";
import { RootState } from "../store";
import RecentTransactions from "./RecentTransactions";
import { setError } from "../store/uiSlice";
import { useGetGuestDetailsQuery } from "../services/managersApi";
import { Transaction } from "../types";
import styled from "@emotion/styled";
import BackButton from "./BackButton";

const PayButton = styled.button`
  background: #f3b900;
  color: #0f0f0f;
  font-family: "Rethink-Sans-Bold", "sans-serif";
  display: flex;
  height: 51px;
  width: 156px;
  padding: 8px 64px;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  cursor: pointer;
  font-size: 16px;
  align-self: center;
  @media (min-width: 768px) {
    font-size: 20px;
  }
`;

const DinerProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useSelector(
    (state: RootState) => state.checkout.selectedLocation,
  );
  const selectedGuest = useSelector(
    (state: RootState) => state.checkout.selectedGuest,
  );
  const {
    data: guestData,
    error: guestError,
    isFetching,
  } = useGetGuestDetailsQuery({
    userId: selectedGuest?.id.toString() ?? "",
    locationId: location?.id.toString() ?? "",
  });

  useEffect(() => {
    if (guestError) {
      dispatch(setError("Failed to fetch transactions."));
    } else {
      dispatch(setError(""));
    }
  }, [guestError, dispatch]);

  useEffect(() => {
    if (guestData) {
      dispatch(setDinerProfile(guestData.user));
    }
  }, [guestData, dispatch]);

  return (
    <StyledDinerSelection>
      <BackButton
        onClick={() => {
          navigate("/diner-selection");
          dispatch(setSelectedGuest(null));
        }}
      ></BackButton>
      {location && <LocationItem location={location} isDiner={true} />}
      {selectedGuest && <GuestItem guest={selectedGuest} mode="dark" />}
      <RecentTransactions
        transactions={(guestData?.user?.transactions ?? []).map(
          (t: Transaction) => ({
            ...t,
            user_name: location?.name ?? "",
          }),
        )}
        isUserTransaction={true}
        isLoading={isFetching}
      />
      <PayButton onClick={() => navigate("/enter-check-number")}>Pay</PayButton>
    </StyledDinerSelection>
  );
};

export default DinerProfile;
